import React, {ChangeEvent, useState} from "react";
import "./SignatureRejectModal.scss";
import {Button} from "../ui-components/Button/Button";
import {AutoExpandableTextarea} from "../AutoExpandableTextarea/AutoExpandableTextarea";
import closeIcon from "../../assets/icons/times-solid.svg";
import {Modal} from "../Modal/Modal";

interface SignatureRejectModalProps {
    onCloseModal: () => void;
    onSubmitModal: (rejectReason: string) => void;
}

export const SignatureRejectModal: React.FunctionComponent<SignatureRejectModalProps> = (props) => {
    const [rejectReason, setRejectReason] = useState<string>('');

    const closeModal = () => {
        props.onCloseModal();
    }

    const onChangeRejectReason = (event: ChangeEvent) => {
        setRejectReason((event.target as HTMLTextAreaElement).value);
    }

    const rejectSignature = () => {
        props.onSubmitModal(rejectReason);
    }

    const renderSignatureRejectContent = () => {
        return (
            <>
                <header>
                    <h1>Reject Contract</h1>
                    <img onClick={closeModal} className='image-icon desktop-2x clickable' src={closeIcon} alt="close"/>
                </header>
                <main className='signature-reject-modal'>
                    <div className='input-container'>
                        <label>Comment</label>
                        <AutoExpandableTextarea value={rejectReason} onChange={onChangeRejectReason} initRows={3}
                                                maxRows={10}/>
                    </div>
                </main>
                <footer>
                    <Button onClick={closeModal}>Cancel</Button>
                    <Button className='cancel-button' onClick={rejectSignature}>Reject</Button>
                </footer>
            </>
        )
    }

    return <Modal>
        {renderSignatureRejectContent()}
    </Modal>

}